<div [formGroup]="form" *ngIf="form" class="form-responsive"
    (keydown.tab)="$event.stopPropagation()"
    (click)="$event.stopPropagation()">
    <div class="form-group">
        <div fxLayout="column">
            <!-- CNPJ (preenche os demais dados) -->
            <mat-form-field appearance="outline" class="min-width has-subscript">
                <mat-label>CNPJ</mat-label>
                <input #cnpjInput matInput formControlName="cnpj" placeholder="00.000.000/0000-00"
                    mask="00.000.000/0000-00" inputmode="numeric">
                <mat-hint>Ao informar o CNPJ, os dados da empresa são preenchidos</mat-hint>
                <mat-error *ngIf="form.get('cnpj')?.invalid">CNPJ inválido</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="min-width">
                <mat-label>Razão social</mat-label>
                <input matInput formControlName="razao_social" placeholder="Razão social do fornecedor" required>
                <mat-error *ngIf="form.get('razao_social')?.hasError('required')">Informe a razão social</mat-error>
            </mat-form-field>

            <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="16px" fxLayoutGap.xs="0">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Telefone</mat-label>
                    <input type="tel" matInput formControlName="phone" placeholder="(00) 00000-0000"
                        mask="(00) 00009-0000" autocomplete="off">
                    <mat-error *ngIf="form.get('phone')?.invalid">Telefone incompleto</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>E-mail</mat-label>
                    <input matInput formControlName="email" placeholder="email@exemplo.com" type="email"
                        inputmode="email" autocapitalize="off">
                    <mat-error *ngIf="form.get('email')?.hasError('email')">E-mail inválido</mat-error>
                </mat-form-field>
            </div>

            <mat-form-field appearance="outline" class="min-width">
                <mat-label>Nome do responsável</mat-label>
                <input matInput formControlName="responsible" placeholder="Nome do contato no fornecedor">
            </mat-form-field>

            <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="16px" fxLayoutGap.xs="0">
                <mat-form-field appearance="outline" fxFlex="30" fxFlex.xs="100">
                    <mat-label>CEP</mat-label>
                    <input matInput formControlName="cep" placeholder="00000-000" mask="00000-000" inputmode="numeric">
                    <mat-error *ngIf="form.get('cep')?.invalid">CEP incompleto</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="70" fxFlex.xs="100">
                    <mat-label>Logradouro</mat-label>
                    <input matInput formControlName="address" placeholder="Rua, avenida etc.">
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="16px" fxLayoutGap.xs="0">
                <mat-form-field appearance="outline" fxFlex="30" fxFlex.xs="100">
                    <mat-label>Número</mat-label>
                    <input matInput formControlName="address_number" placeholder="123">
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="70" fxFlex.xs="100">
                    <mat-label>Complemento</mat-label>
                    <input matInput formControlName="address_complement" placeholder="Sala, andar etc.">
                </mat-form-field>
            </div>

            <mat-form-field appearance="outline" class="min-width">
                <mat-label>Bairro</mat-label>
                <input matInput formControlName="address_neighborhood" placeholder="Bairro">
            </mat-form-field>

            <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="16px" fxLayoutGap.xs="0">
                <mat-form-field appearance="outline" fxFlex="70" fxFlex.xs="100">
                    <mat-label>Cidade</mat-label>
                    <input matInput formControlName="address_city" placeholder="Cidade">
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="30" fxFlex.xs="100">
                    <mat-label>Estado</mat-label>
                    <input matInput formControlName="address_state" placeholder="UF" maxlength="2"
                        autocapitalize="characters">
                </mat-form-field>
            </div>

            <!-- Status (apenas na edição) -->
            <div *ngIf="supplier?.id" class="status-row">
                <span>Status do fornecedor</span>
                <orca-switch [isActive]="supplier?.status == 1" ariaLabel="Status do fornecedor"
                    (toggle)="toggleStatus($event)"></orca-switch>
            </div>
        </div>
    </div>

    <!-- Fora de diálogo (uso direto na página) -->
    <div *ngIf="!inDialog" class="form-actions">
        <button *ngIf="!supplier?.id" type="button" class="oa-btn oa-btn--primary"
            [disabled]="loading || !form.dirty || !form.valid" [attr.aria-busy]="loading || null" (click)="store()">
            <span>Criar fornecedor</span>
            <span *ngIf="loading" class="oa-spinner" aria-hidden="true"></span>
        </button>
        <button *ngIf="supplier?.id" type="button" class="oa-btn oa-btn--primary"
            [disabled]="loading || !form.dirty || !form.valid" [attr.aria-busy]="loading || null" (click)="update()">
            <span>Salvar alterações</span>
            <span *ngIf="loading" class="oa-spinner" aria-hidden="true"></span>
        </button>
    </div>
</div>
